import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-57131a13")

_pushScopeId("data-v-57131a13")
const _hoisted_1 = {
  key: 0,
  class: "photoList"
}
const _hoisted_2 = { class: "ui__photoList_Box" }
const _hoisted_3 = { class: "ui__photoList_title" }
const _hoisted_4 = { class: "ui__photoList_PhotoList" }
const _hoisted_5 = { class: "ui__photoList_item_text" }
const _hoisted_6 = {
  key: 1,
  class: "photoListAll"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_pageTitle = _resolveComponent("pageTitle")
  const _component_photoListAll = _resolveComponent("photoListAll")

  return (_openBlock(), _createBlock("div", {
    class: ["ui__photoList_main", {'isAll':_ctx.state.isAll}],
    style: {minHeight:_ctx.state.clientHeight + 'px'}
  }, [
    (!_ctx.state.isShowSwiper)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode(_component_pageTitle, {
            titleText: _ctx.state.modelName,
            backFun: _ctx.state.backFun,
            onHiddenSwiperByTitle: _ctx.hiddenSwiperByTitle
          }, null, 8, ["titleText", "backFun", "onHiddenSwiperByTitle"]),
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.listTab, (item) => {
                return _withDirectives((_openBlock(), _createBlock("div", {
                  class: ["ui__photoList_tab", {'ui__actTab':item.id === _ctx.state.actTab}],
                  key: item.id,
                  onClick: ($event: any) => (_ctx.changePhotoType(item.id))
                }, [
                  _createVNode("span", null, _toDisplayString(item.name), 1)
                ], 10, ["onClick"])), [
                  [_vShow, item.num > 0]
                ])
              }), 128))
            ]),
            _createVNode("div", _hoisted_4, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.photoList, (item) => {
                return (_openBlock(), _createBlock("div", {
                  class: "ui__photoList_item",
                  key: item.photoIdStr
                }, [
                  _createVNode("div", {
                    class: "ui__photoList_item_img",
                    onClick: ($event: any) => (_ctx.showSwiper(item))
                  }, [
                    _createVNode("img", {
                      src: item.smallPhotoUrl ? _ctx.urlConversion(item.smallPhotoUrl) : _ctx.urlConversion(item.photoPath)
                    }, null, 8, ["src"])
                  ], 8, ["onClick"]),
                  _createVNode("div", _hoisted_5, [
                    _createVNode("span", null, _toDisplayString(item.photoName), 1)
                  ])
                ]))
              }), 128))
            ])
          ])
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_6, [
          _createVNode(_component_photoListAll, {
            onAllPhont: _ctx.allPhont,
            initialSlide: _ctx.state.initialSlide,
            backFun: _ctx.state.backFun,
            onHiddenSwiperByTitle: _ctx.hiddenSwiperByTitle
          }, null, 8, ["onAllPhont", "initialSlide", "backFun", "onHiddenSwiperByTitle"])
        ]))
  ], 6))
})